package org.tlsys.dto

import libs.Date
import libs.date
import libs.month
import libs.year

fun Date.toDateDay() = DateDay(year = year, month = month + 1, day = date)
fun DateDay.toDate() = Date(year = year, month = month - 1, day = day)